import { createAction, props } from '@ngrx/store';
import { SignUpSmartSearchState } from '@shared-lib/models/sign-up/sign-up-smart-search.state';
import { SmartSearchFormValues } from '@shared-lib/models/sign-up/sign-up-smart-search/smart-search-form.model';

export const loadSignUpSmartSearchFromStorage = createAction('[SIGN UP] Load Smart Search From Storage');
export const loadSignUpSmartSearchFromStorageSuccess = createAction(
  '[SIGN UP]  Load Smart Search From Storage Success',
  props<{ state: SignUpSmartSearchState | null }>(),
);

export const setSignUpSmartSearchState = createAction('[SIGN UP] Set Smart Search State', props<SignUpSmartSearchState>());

export const setSignUpSmartSearchForm = createAction('[SIGN UP]  Set Smart Search Form', props<SmartSearchFormValues>());

export const clearSignUpSmartSearchFromStorage = createAction('[SIGN UP] Clear Smart Search Form');

export const skipSignUpSmartSearchCreation = createAction('[SIGN UP] Skip Smart Search Creation');
